import { Injectable } from '@angular/core';
import { LsHelperService } from './ls-helper.service';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { GlobalsService } from './globals.service';
import { BaseProvider } from './base-provider';
import { Subject } from 'rxjs';
import { LookupService } from './lookup.service';

@Injectable({
  providedIn: 'root',
})
export class MultiLanguageService extends BaseProvider {
  ml: any;
  currentLanguage: any = 'es';
  retrigger: any;
  isLoading: boolean = false;

  languageChangeEvent = new Subject();

  constructor(
    public globals: GlobalsService,
    public http: HttpClient,
    public ls: LsHelperService,
    public lookupService: LookupService,
    private translate: TranslateService
  ) {
    super();

    this.baseUrl = 'lookup';
  }

  setCurrentLanguage() {
    var lang = this.ls.get('SELECTED_LANGUAGE');

    this.currentLanguage = lang ? lang : 'es';
  }

  trigger() {
    this.setCurrentLanguage();

    this.retrigger = new Date().getTime();
  }

  translateLabel(label) {
    var returnLabel = label;

    if(returnLabel == null || returnLabel == 'null'){
      return '';
    }

    try {
      returnLabel = this.ml[`${this.currentLanguage}.${label}`];

      if (returnLabel == undefined) {
        returnLabel = label;
      }
    } catch (e) {}

    return returnLabel;
  }

  verifyVersion() {
    return new Promise((resolve, reject) => {
      if (this.isLoading) resolve(null);

      this.setCurrentLanguage();

      this.isLoading = true;

      this.url = this.globals.dataUrl + this.baseUrl + '/hub/MLVersion/true';

      this.http.get(this.url).subscribe(
        (data: any) => {
          let config = JSON.parse(data[0])[0];

          let version = this.ls.get('MLVersion');

          if (version != config.value) {
            this.getLatestLanguage().then(() => {
              this.ls.set('MLVersion', config.value);

              this.ml = this.ls.get('ML');

              this.isLoading = false;

              //console.log("trigger");

              this.trigger();

              this.lookupService.setArrayLanguage();

              resolve(null);
            });
          } else {
            this.ml = this.ls.get('ML');

            this.lookupService.setArrayLanguage();

            this.isLoading = false;

            resolve(null);
          }
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getLatestLanguage() {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/hub/ML/true';

      this.http.get(this.url).subscribe(
        (data: any) => {
          let config = JSON.parse(data[0])[0];

          let ml = JSON.parse(config.value);

          this.ls.set('ML', ml);

          resolve(null);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  toggleLanguage() {
    var lang = this.ls.get('SELECTED_LANGUAGE');

    this.currentLanguage = lang == 'es' ? 'en' : 'es';

    this.translate.use(this.currentLanguage);

    this.ls.set('SELECTED_LANGUAGE', this.currentLanguage);

    this.trigger();

    this.languageChangeEvent.next(this.currentLanguage);

    this.lookupService.setArrayLanguage();
  }
}
